export class Mutex {
  private lock: Promise<void> = Promise.resolve();

  /**
   * Runs the provided function exclusively, ensuring
   * only one runs at a time in order of requests.
   */
  async run<T>(fn: () => Promise<T> | T): Promise<T> {
    let release: () => void;

    // Create a promise that resolves when this lock is released
    const wait = new Promise<void>(resolve => {
      release = resolve;
    });

    // Store the current lock so the next call waits for it
    const previousLock = this.lock;
    this.lock = previousLock.then(() => wait);

    // Wait for previous execution to complete
    await previousLock;

    try {
      // Execute the provided function and return its result
      return await fn();
    } finally {
      // Release the lock so the next queued call can proceed
      release!();
    }
  }
}
